<template>
  <v-card class="rounded-xl overflow-hidden" elevation="2">

    <!-- ── Header ── -->
    <v-card-title class="pa-0">
      <div class="form-header">
        <div class="d-flex align-center" style="gap: 10px;">
          <v-icon color="white" size="20">mdi-folder-plus-outline</v-icon>
          <div>
            <div class="font-weight-black subtitle-1 white--text" style="line-height:1.2;">
              {{ isNewProject ? 'Nuevo Proyecto SAP' : 'Editar Proyecto SAP' }}
            </div>
            <div class="caption white--text" style="opacity:.72;">
              {{ isNewProject ? 'Registro en SAP Business One' : `Modificando: ${projectForm.PrjCode}` }}
            </div>
          </div>
        </div>
        <v-btn icon small color="white" @click="$emit('close')" style="background: rgba(255,255,255,0.15);">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <!-- ── Body ── -->
    <v-card-text class="pt-5 pb-2 px-5">
      <v-form ref="formProject" lazy-validation>

        <!-- Identificación -->
        <!-- <div class="section-title mb-3">
          <v-icon small color="blue darken-2" class="mr-1">mdi-identifier</v-icon>
          Identificación
        </div> -->

        <v-row dense>
          <!-- <v-col cols="12" sm="4">
            <span class="caption font-weight-bold grey--text text--darken-1 d-block">
              Código de Proyecto *
            </span>
            <v-text-field id="inp-prj-code" v-model.trim="projectForm.PrjCode" outlined dense hide-details="auto"
              class="mb-3 rounded-lg" :disabled="!isNewProject" autocomplete="off"
              :hint="!isNewProject ? 'No editable en modo edición' : ''" placeholder="Ej: P-0001" />
          </v-col> -->

          <v-col cols="12" sm="12">
            <span class="caption font-weight-bold grey--text text--darken-1 d-block">
              Nombre del Proyecto *
            </span>
            <v-text-field id="inp-prj-name" v-model.trim="projectForm.PrjName" outlined dense hide-details="auto"
              class="mb-3 rounded-lg" autocomplete="off" placeholder="Descripción completa del proyecto" />
          </v-col>
        </v-row>

        <!-- Vigencia -->
        <!-- <div class="section-title mb-3">
          <v-icon small color="amber darken-3" class="mr-1">mdi-calendar-range</v-icon>
          Vigencia
        </div> -->

        <!-- <v-row dense>
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold grey--text text--darken-1 d-block">
              Válido Desde
            </span>
            <v-text-field id="inp-valid-from" v-model="projectForm.ValidFrom" type="date" outlined dense
              hide-details="auto" class="mb-3 rounded-lg" clearable />
          </v-col>

          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold grey--text text--darken-1 d-block">
              Válido Hasta
            </span>
            <v-text-field id="inp-valid-to" v-model="projectForm.ValidTo" type="date" outlined dense hide-details="auto"
              class="mb-3 rounded-lg" clearable />
          </v-col>
        </v-row> -->

        <!-- Estados -->
        <div class="section-title mb-3">
          <v-icon small color="purple darken-2" class="mr-1">mdi-toggle-switch-outline</v-icon>
          Estados SAP
        </div>

        <v-row dense class="mb-2">
          <v-col cols="12" sm="6">
            <div class="toggle-card" :class="isActive ? 'toggle-card--active' : ''">
              <div class="d-flex align-center flex-1" style="gap:8px;">
                <v-icon size="18" :color="isActive ? 'green darken-1' : 'grey darken-1'">
                  {{ isActive ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
                </v-icon>
                <div>
                  <div class="caption font-weight-bold grey--text text--darken-2" style="line-height:1.2;">
                    Activo</div>
                  <div class="caption grey--text" style="font-size:10px;">El proyecto está operativo</div>
                </div>
              </div>
              <div class="d-flex align-center" style="gap:6px;">
                <v-chip x-small :color="isActive ? 'green' : 'grey lighten-1'" :dark="isActive"
                  class="font-weight-black" style="min-width:24px; justify-content:center;">
                  {{ isActive ? 'Y' : 'N' }}
                </v-chip>
                <v-switch id="sw-active" v-model="isActive" dense hide-details color="green darken-1"
                  class="mt-0 pt-0" />
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="toggle-card" :class="isLocked ? 'toggle-card--locked' : ''">
              <div class="d-flex align-center flex-1" style="gap:8px;">
                <v-icon size="18" :color="isLocked ? 'red darken-1' : 'grey darken-1'">
                  {{ isLocked ? 'mdi-lock' : 'mdi-lock-open-variant-outline' }}
                </v-icon>
                <div>
                  <div class="caption font-weight-bold grey--text text--darken-2" style="line-height:1.2;">
                    Bloqueado
                  </div>
                  <div class="caption grey--text" style="font-size:10px;">Impide realizar movimientos</div>
                </div>
              </div>
              <div class="d-flex align-center" style="gap:6px;">
                <v-chip x-small :color="isLocked ? 'red darken-1' : 'grey lighten-1'" :dark="isLocked"
                  class="font-weight-black" style="min-width:24px; justify-content:center;">
                  {{ isLocked ? 'Y' : 'N' }}
                </v-chip>
                <v-switch id="sw-locked" v-model="isLocked" dense hide-details color="red darken-1" class="mt-0 pt-0" />
              </div>
            </div>
          </v-col>
        </v-row>

      </v-form>
    </v-card-text>

    <v-divider />

    <!-- ── Acciones ── -->
    <v-card-actions class="px-5 py-3">
      <v-spacer />
      <v-btn depressed color="red darken-1" dark @click="$emit('close')" class="mr-1 text-none rounded-lg">
        <v-icon left small>mdi-close</v-icon>
        CERRAR
      </v-btn>
      <v-btn id="btn-submit-project" color="blue darken-2" dark depressed :loading="loading" :disabled="loading"
        class="rounded-lg text-none font-weight-bold" style="letter-spacing:0.01em;" @click="saveProject">
        <v-icon left small>mdi-content-save</v-icon>
        GUARDAR
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import _TrsBudgeService from "@/services/Treasury/TrsBudgeService";

export default {
  name: "TrsProjectForm",

  props: {
    isNewProject: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      projectForm: {
        PrjCode: "",
        PrjName: "",
        Locked: "Y",
        DataSource: "I",
        ValidFrom: null,
        ValidTo: null,
        Active: "Y",
        LogInstanc: 0,
        // IsNew: true,
      },
    };
  },

  computed: {
    isLocked: {
      get() { return this.projectForm.Locked === "Y"; },
      set(value) { this.projectForm.Locked = value ? "Y" : "N"; },
    },
    isActive: {
      get() { return this.projectForm.Active === "Y"; },
      set(value) { this.projectForm.Active = value ? "Y" : "N"; },
    },
  },

  methods: {
    async saveProject() {
      // if (!this.projectForm.PrjCode || this.projectForm.PrjCode.trim() === "") {
      //   this.$fun.alert("Debe ingresar el Código de Proyecto.", "warning");
      //   return;
      // }

      if (!this.projectForm.PrjName || this.projectForm.PrjName.trim() === "") {
        this.$fun.alert("Debe ingresar el Nombre del Proyecto.", "warning");
        return;
      }

      // if (this.projectForm.ValidFrom && this.projectForm.ValidTo) {
      //   const from = new Date(this.projectForm.ValidFrom);
      //   const to = new Date(this.projectForm.ValidTo);
      //   if (from > to) {
      //     this.$fun.alert("La fecha de inicio no puede ser mayor a la fecha de fin.", "warning");
      //     return;
      //   }
      // }

      this.loading = true;
      // this.projectForm.IsNew = this.isNewProject;

      try {
        console.log(JSON.parse(JSON.stringify({ projectForm: this.projectForm })))
        const response = await _TrsBudgeService.saveProject(this.projectForm, this.$fun.getUserID());

        if (response.status == 200) {
          this.$fun.alert(
            `Proyecto "${this.projectForm.PrjCode}" creado exitosamente.`,
            // this.isNewProject
            //   ? `Proyecto "${this.projectForm.PrjCode}" creado exitosamente.`
            //   : `Proyecto "${this.projectForm.PrjCode}" actualizado correctamente.`,
            "success"
          );
          this.$emit("saved", response.data);
        }
      } catch (error) {
        let message = "Ocurrió un error inesperado al guardar el proyecto.";
        if (error.response && error.response.data) {
          const d = error.response.data;
          if (typeof d === "string" && d.length > 0) message = d;
          else if (d.message) message = d.message;
          else if (d.Message) message = d.Message;
        }
        this.$fun.alert(message, "error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ── Header gradient ── */
.form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1565c0, #1976d2);
  border-bottom: 1px solid #1e40af;
}

/* ── Section labels ── */
.section-title {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #546e7a;
}

/* ── Toggle cards ── */
.toggle-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid #e0e0e0;
  background: #fafafa;
  transition: border-color 0.2s, background 0.2s;
  min-height: 54px;
}

.toggle-card--active {
  border-color: #81c784;
  background: #f1faf1;
}

.toggle-card--locked {
  border-color: #e57373;
  background: #fff5f5;
}

.flex-1 {
  flex: 1;
}
</style>
